$(document).ready(function(){
 
  var element = $('.feature-video--root');
  var youtube_script_added, vimeo_script_added;

  
  function hideThumbnail() {    
    element.find('.feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile').hide();    
  }

  function playButtonListener(play_buttons, video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player) {
    play_buttons.attr('tabindex', '0');
    play_buttons.on('click keydown', function(event) {
      if (event.type === 'keydown' && event.key !== 'Enter') {
        return;
      }
      checkAPIScriptExists(video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player);
      hideThumbnail();
    });
  }

  function disablePlayerFocus(section_id) {        
    $('#player-'+section_id).find('.loader').remove();        
    element.find('iframe').attr('tabindex', '-1');
  }

  function vimeoEvents() {
    player.getDuration().then(function(duration) {
      return player.addCuePoint(duration - 0.3, {});
    });
    return player.on('cuepoint', function() {
      player.setCurrentTime(0);
      return player.pause();
    });
  }

  function insertVimeoPlayer(thumbnail, vimeoVars, section_id) {
    if (!thumbnail) {
      vimeoVars.playsinline = 1;
      vimeoVars.mute = 1;
      vimeoVars.background = 1;
      vimeoVars.loop = 1;
      vimeoVars.controls = 0;
    }
    player = new Vimeo.Player("player-" + section_id, vimeoVars);
    if (thumbnail) {
      vimeoEvents(player);
    } else {
      player.ready().then(function() {
        return disablePlayerFocus(section_id);
      });
    }
    return player.play();
  }

  function youtubeEvents(event, thumbnail) {  
    var YTP, remains, rewindTO;     
    YTP = event.target;
    if (thumbnail) {
      if (event.data === 0) {
        YTP.seekTo(0);
        return YTP.pauseVideo();
      }
    } else {      
      if (event.data === 1) {
        remains = YTP.getDuration() - YTP.getCurrentTime();
        if (rewindTO) {
          clearTimeout(rewindTO);
        }
        return rewindTO = setTimeout(function() {
          YTP.seekTo(0);
        }, (remains - 0.1) * 100);
      }
    }
  }


  function insertYoutubePlayer(thumbnail, section_id, youtubeVars, video_id, player) {
    function youtubeReady() {      
      if (!thumbnail) {
        player.mute();
        disablePlayerFocus(section_id);
      }
      return player.playVideo();
    }
    if (!thumbnail) {
      youtubeVars.enablejsapi = 1;
      // youtubeVars.origin = window.location.href;
      youtubeVars.playsinline = 1;
      youtubeVars.fs = 0;
      youtubeVars.loop = 1;
      youtubeVars.mute = 1;
      youtubeVars.autoplay = 1;
      youtubeVars.controls = 0;
      youtubeVars.playlist = video_id;
    }    
    if (typeof YT !== 'undefined') {         
      return player = new YT.Player("player-" + section_id, {
        videoId: video_id,
        playerVars: youtubeVars,
        events: {
          'onReady': youtubeReady,
          'onStateChange': youtubeEvents
        }
      });
    }
  }
  
  function insertScript(src, callback) {
    var script;
    script = document.createElement('script');
    script.src = src;
    if (callback) {
      script.onload = callback;
    }
    return document.body.appendChild(script);
  }
  
  function insertAPIScript(video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player) {    
    if (video_type === 'vimeo') {
      var vimeo_script_added = true;
      return insertScript('https://player.vimeo.com/api/player.js', function() {
        return insertVimeoPlayer(thumbnail, vimeoVars, section_id, player);
      });
    } else {
      var youtube_script_added = true;
      insertScript('https://www.youtube.com/iframe_api');
      return window.addEventListener('theme:utils:youtubeAPIReady', function() {
        return insertYoutubePlayer(thumbnail, section_id, youtubeVars, video_id, player);
      });
    }
  }
  
  function playerInit(video_type, thumbnail) {
    if (video_type === 'vimeo') {
      if (thumbnail) {
        return insertVimeoPlayer();
      } else {
        window.addEventListener('load', function() {
          return insertVimeoPlayer();
        });
        return element.on('theme:section:load', function() {
          return insertVimeoPlayer();
        });
      }
    } else {
      if (thumbnail) {
        return insertYoutubePlayer();
      } else {
        window.addEventListener('load', function() {
          return insertYoutubePlayer();
        });
        return element.on('theme:section:load', function() {
          return insertYoutubePlayer();
        });
      }
    }
  }

  function checkAPIScriptExists(video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player) {    
    if (video_type === 'vimeo') {
      if (vimeo_script_added) {
        return playerInit();
      } else {
        return insertAPIScript(video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player);
      }
    } else {
      if (youtube_script_added) {
        return playerInit();
      } else {
        return insertAPIScript(video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player);
      }
    }
  }

  function FrameworkFeaturedVideo(root) {   
    var play_buttons = root.find('.feature-video--play svg, .feature-video--play-mobile svg');
    var section_id = root.attr('data-section-id');
    var thumbnail = root.data('thumbnail');
    var video_type = root.data('video-type');
    var video_id = root.data('video-id');
    var player;
    var vimeoVars = {
      id: video_id,
      autopause: 0,
      playsinline: 0,
      title: 0
    };
    
    var youtubeVars = {};
     console.log(root.find('video'),'get');
    if(root.find('video')){     
      var video = root.find('video');                    
      if (video[0]) {
        if(video[0].paused){
          video[0].play();
        }else{
          video[0].pause();
        }
      }
    }
    if (thumbnail) {      
      playButtonListener(play_buttons, video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player);
    } else {
      checkAPIScriptExists(video_type, thumbnail, section_id, vimeoVars, youtubeVars, video_id, player);
    }    
  }
  $('.feature-video--root').each(function(i, v) {  
    console.log(v,'vvvvv',i);
    FrameworkFeaturedVideo($(v))
  });
})